import { useQuery } from '@tanstack/react-query';

import { documentsApi } from 'domain/documents/api';
import { queryOptions } from 'services/query';

import { documentsKeys } from './keys';

// Read-only document processing/count snapshot. companyId is in the key for per-company cache
// isolation (the CompanyId header carries scope to the backend). The only consumer is the
// Configurations → General fin-toggle guard, which needs a single derived flag — whether the
// `fin` feature may be disabled (no documents processing AND no financial documents present) —
// so `select` narrows the payload to that boolean, mirroring the legacy isDisablingFinAllowedSelector.
export const dashboardStatsQuery = (companyId: string) =>
  queryOptions({
    queryKey: documentsKeys.dashboardStats(companyId),
    queryFn: () => documentsApi.getDashboardStats(),
    select: (data) => data.processing === 0 && data.total.fin === 0,
  });

export const useIsDisablingFinAllowed = (companyId: string) =>
  useQuery({ ...dashboardStatsQuery(companyId), enabled: Boolean(companyId) });
